import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-down",
  "use": "icon-caret-down-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-caret-down\">\n<path d=\"M4.4737 5.52637C4.28211 5.52637 4.10939 5.64178 4.03607 5.81878C3.96275 5.99578 4.00328 6.19952 4.13875 6.33499L6.66506 8.8613C6.85004 9.04628 7.14996 9.04628 7.33494 8.8613L9.86125 6.33499C9.99672 6.19952 10.0372 5.99578 9.96393 5.81878C9.89061 5.64178 9.71789 5.52637 9.5263 5.52637H4.4737Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol